import React from 'react';
import { motion } from 'framer-motion';
export function ContactUs() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="w-full min-h-screen bg-white" data-id="element-129">
      {/* Hero Section */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50 text-zinc-950" data-id="element-130">
        <div className="max-w-4xl mx-auto text-center" data-id="element-131">
          <motion.p className="text-sm tracking-[0.3em] uppercase mb-8 text-zinc-600" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-132">
            Get in Touch
          </motion.p>
          <motion.h1 className="text-5xl md:text-7xl font-serif mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif'
        }} initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-133">
            Contact Us
          </motion.h1>
          <motion.p className="text-lg md:text-xl text-zinc-600 leading-relaxed max-w-2xl mx-auto" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-134">
            Begin your journey to cellular wellness. Our team is here to answer
            your questions.
          </motion.p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="px-6 py-32 md:py-40 bg-white" data-id="element-135">
        <div className="max-w-7xl mx-auto" data-id="element-136">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-137">
            {/* Contact Form */}
            <motion.div initial={{
            x: -30,
            opacity: 0
          }} animate={{
            x: 0,
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} data-id="element-138">
              <h2 className="text-3xl md:text-4xl font-serif mb-8 text-zinc-950" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-139">
                Send Us a Message
              </h2>
              <form className="space-y-6" data-id="element-140">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-141">
                  <div data-id="element-142">
                    <label className="block text-sm tracking-[0.1em] uppercase text-zinc-600 mb-2" data-id="element-143">
                      First Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" data-id="element-144" />
                  </div>
                  <div data-id="element-145">
                    <label className="block text-sm tracking-[0.1em] uppercase text-zinc-600 mb-2" data-id="element-146">
                      Last Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" data-id="element-147" />
                  </div>
                </div>
                <div data-id="element-148">
                  <label className="block text-sm tracking-[0.1em] uppercase text-zinc-600 mb-2" data-id="element-149">
                    Email
                  </label>
                  <input type="email" className="w-full px-4 py-3 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" data-id="element-150" />
                </div>
                <div data-id="element-151">
                  <label className="block text-sm tracking-[0.1em] uppercase text-zinc-600 mb-2" data-id="element-152">
                    Phone
                  </label>
                  <input type="tel" className="w-full px-4 py-3 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors" data-id="element-153" />
                </div>
                <div data-id="element-154">
                  <label className="block text-sm tracking-[0.1em] uppercase text-zinc-600 mb-2" data-id="element-155">
                    Message
                  </label>
                  <textarea rows={6} className="w-full px-4 py-3 border border-zinc-300 focus:border-zinc-950 focus:outline-none transition-colors resize-none" data-id="element-156" />
                </div>
                <button type="submit" className="w-full py-4 bg-zinc-950 text-white text-sm tracking-[0.2em] uppercase font-medium hover:bg-zinc-800 transition-colors" data-id="element-157">
                  Send Message
                </button>
              </form>
            </motion.div>

            {/* Contact Information */}
            <motion.div className="space-y-12" initial={{
            x: 30,
            opacity: 0
          }} animate={{
            x: 0,
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-158">
              <div data-id="element-159">
                <h3 className="text-2xl font-serif mb-6 text-zinc-950" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-160">
                  Visit Our Clinic
                </h3>
                <div className="space-y-4 text-zinc-600" data-id="element-161">
                  <p className="text-lg" data-id="element-162">
                    123 Wellness Boulevard
                    <br data-id="element-163" />
                    Suite 500
                    <br data-id="element-164" />
                    Beverly Hills, CA 90210
                  </p>
                </div>
              </div>

              <div data-id="element-165">
                <h3 className="text-2xl font-serif mb-6 text-zinc-950" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-166">
                  Contact Information
                </h3>
                <div className="space-y-4 text-zinc-600" data-id="element-167">
                  <div data-id="element-168">
                    <p className="text-sm tracking-[0.1em] uppercase mb-1" data-id="element-169">
                      Phone
                    </p>
                    <p className="text-lg" data-id="element-170">(310) 555-0123</p>
                  </div>
                  <div data-id="element-171">
                    <p className="text-sm tracking-[0.1em] uppercase mb-1" data-id="element-172">
                      Email
                    </p>
                    <p className="text-lg" data-id="element-173">hello@celivionlongevity.com</p>
                  </div>
                </div>
              </div>

              <div data-id="element-174">
                <h3 className="text-2xl font-serif mb-6 text-zinc-950" style={{
                fontFamily: 'Playfair Display, serif'
              }} data-id="element-175">
                  Hours
                </h3>
                <div className="space-y-3 text-zinc-600" data-id="element-176">
                  <div className="flex justify-between" data-id="element-177">
                    <span data-id="element-178">Monday - Friday</span>
                    <span data-id="element-179">9:00 AM - 7:00 PM</span>
                  </div>
                  <div className="flex justify-between" data-id="element-180">
                    <span data-id="element-181">Saturday</span>
                    <span data-id="element-182">10:00 AM - 5:00 PM</span>
                  </div>
                  <div className="flex justify-between" data-id="element-183">
                    <span data-id="element-184">Sunday</span>
                    <span data-id="element-185">By Appointment</span>
                  </div>
                </div>
              </div>

              <div className="pt-8 border-t border-zinc-200" data-id="element-186">
                <p className="text-zinc-600 leading-relaxed" data-id="element-187">
                  For urgent inquiries or to schedule a consultation, please
                  call our concierge team directly. We're here to support your
                  wellness journey.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </motion.div>;
}